import { Fragment } from "react";
import { Image, LI, P, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { ContactWrapperData } from "../../../../../Data/Applications/Chat/Chat";

export const ContactList = () => {
  return (
    <div className="contact-wrapper">
      {ContactWrapperData.map((data, index) => (
        <Fragment key={index}>
          <P>{data.mainLetter}</P>
          {data.contactData.map((item, i) => (
            <UL className="border-0 simple-list flex-row" key={i}>
              <LI className="common-space">
                <div className="chat-time">
                  {item.image && <Image className="img-fluid rounded-circle" src={dynamicImage(`${item.image}`)} alt="user" />}
                  {item.imageUser && (
                    <div className={`custom-name bg-light-${item.color}`}>
                      <P className={`txt-${item.color} f-w-500`}>{item.imageUser}</P>
                    </div>
                  )}
                  <div>
                    <span>{item.name}</span>
                    <P>{item.phoneNumber}</P>
                  </div>
                </div>
              </LI>
            </UL>
          ))}
        </Fragment>
      ))}
    </div>
  );
};
